var map = {
	"./ion-action-sheet-ios.entry.js": [
		342,
		118
	],
	"./ion-action-sheet-md.entry.js": [
		343,
		119
	],
	"./ion-alert-ios.entry.js": [
		344,
		100
	],
	"./ion-alert-md.entry.js": [
		345,
		101
	],
	"./ion-app_8-ios.entry.js": [
		346,
		80
	],
	"./ion-app_8-md.entry.js": [
		347,
		81
	],
	"./ion-avatar_3-ios.entry.js": [
		348,
		120
	],
	"./ion-avatar_3-md.entry.js": [
		349,
		121
	],
	"./ion-back-button-ios.entry.js": [
		350,
		122
	],
	"./ion-back-button-md.entry.js": [
		351,
		123
	],
	"./ion-backdrop-ios.entry.js": [
		352,
		163
	],
	"./ion-backdrop-md.entry.js": [
		353,
		164
	],
	"./ion-button_2-ios.entry.js": [
		354,
		124
	],
	"./ion-button_2-md.entry.js": [
		355,
		125
	],
	"./ion-card_5-ios.entry.js": [
		356,
		126
	],
	"./ion-card_5-md.entry.js": [
		357,
		127
	],
	"./ion-checkbox-ios.entry.js": [
		358,
		128
	],
	"./ion-checkbox-md.entry.js": [
		359,
		129
	],
	"./ion-chip-ios.entry.js": [
		360,
		130
	],
	"./ion-chip-md.entry.js": [
		361,
		131
	],
	"./ion-col_3.entry.js": [
		362,
		165
	],
	"./ion-datetime_3-ios.entry.js": [
		363,
		96
	],
	"./ion-datetime_3-md.entry.js": [
		364,
		97
	],
	"./ion-fab_3-ios.entry.js": [
		365,
		132
	],
	"./ion-fab_3-md.entry.js": [
		366,
		133
	],
	"./ion-img.entry.js": [
		367,
		166
	],
	"./ion-infinite-scroll_2-ios.entry.js": [
		368,
		116
	],
	"./ion-infinite-scroll_2-md.entry.js": [
		369,
		117
	],
	"./ion-input-ios.entry.js": [
		370,
		134
	],
	"./ion-input-md.entry.js": [
		371,
		135
	],
	"./ion-item-option_3-ios.entry.js": [
		372,
		136
	],
	"./ion-item-option_3-md.entry.js": [
		373,
		137
	],
	"./ion-item_8-ios.entry.js": [
		374,
		138
	],
	"./ion-item_8-md.entry.js": [
		375,
		139
	],
	"./ion-loading-ios.entry.js": [
		376,
		102
	],
	"./ion-loading-md.entry.js": [
		377,
		103
	],
	"./ion-menu_3-ios.entry.js": [
		378,
		140
	],
	"./ion-menu_3-md.entry.js": [
		379,
		141
	],
	"./ion-modal-ios.entry.js": [
		380,
		82
	],
	"./ion-modal-md.entry.js": [
		381,
		83
	],
	"./ion-nav_2.entry.js": [
		382,
		95
	],
	"./ion-popover-ios.entry.js": [
		383,
		84
	],
	"./ion-popover-md.entry.js": [
		384,
		85
	],
	"./ion-progress-bar-ios.entry.js": [
		385,
		142
	],
	"./ion-progress-bar-md.entry.js": [
		386,
		143
	],
	"./ion-radio_2-ios.entry.js": [
		387,
		144
	],
	"./ion-radio_2-md.entry.js": [
		388,
		145
	],
	"./ion-range-ios.entry.js": [
		389,
		146
	],
	"./ion-range-md.entry.js": [
		390,
		147
	],
	"./ion-refresher_2-ios.entry.js": [
		391,
		104
	],
	"./ion-refresher_2-md.entry.js": [
		392,
		105
	],
	"./ion-reorder_2-ios.entry.js": [
		393,
		114
	],
	"./ion-reorder_2-md.entry.js": [
		394,
		115
	],
	"./ion-ripple-effect.entry.js": [
		395,
		167
	],
	"./ion-route_4.entry.js": [
		396,
		148
	],
	"./ion-searchbar-ios.entry.js": [
		397,
		149
	],
	"./ion-searchbar-md.entry.js": [
		398,
		150
	],
	"./ion-segment_2-ios.entry.js": [
		399,
		151
	],
	"./ion-segment_2-md.entry.js": [
		400,
		152
	],
	"./ion-select_3-ios.entry.js": [
		401,
		153
	],
	"./ion-select_3-md.entry.js": [
		402,
		154
	],
	"./ion-slide_2-ios.entry.js": [
		403,
		168
	],
	"./ion-slide_2-md.entry.js": [
		404,
		169
	],
	"./ion-spinner.entry.js": [
		405,
		108
	],
	"./ion-split-pane-ios.entry.js": [
		406,
		170
	],
	"./ion-split-pane-md.entry.js": [
		407,
		171
	],
	"./ion-tab-bar_2-ios.entry.js": [
		408,
		155
	],
	"./ion-tab-bar_2-md.entry.js": [
		409,
		156
	],
	"./ion-tab_2.entry.js": [
		410,
		113
	],
	"./ion-text.entry.js": [
		411,
		157
	],
	"./ion-textarea-ios.entry.js": [
		412,
		158
	],
	"./ion-textarea-md.entry.js": [
		413,
		159
	],
	"./ion-toast-ios.entry.js": [
		414,
		106
	],
	"./ion-toast-md.entry.js": [
		415,
		107
	],
	"./ion-toggle-ios.entry.js": [
		416,
		98
	],
	"./ion-toggle-md.entry.js": [
		417,
		99
	],
	"./ion-virtual-scroll.entry.js": [
		418,
		172
	]
};
function webpackAsyncContext(req) {
	if(!__webpack_require__.o(map, req)) {
		return Promise.resolve().then(function() {
			var e = new Error("Cannot find module '" + req + "'");
			e.code = 'MODULE_NOT_FOUND';
			throw e;
		});
	}

	var ids = map[req], id = ids[0];
	return __webpack_require__.e(ids[1]).then(function() {
		return __webpack_require__(id);
	});
}
webpackAsyncContext.keys = function webpackAsyncContextKeys() {
	return Object.keys(map);
};
webpackAsyncContext.id = 306;
module.exports = webpackAsyncContext;